import React from 'react';
import { Reveal, SectionLabel, BtnRed, BtnGhost, CtaBanner } from '../components/common';
import { images, aboutRoles, aboutBlocks } from '../mock/mock';

export default function DetrasDelEscenario() {
  return (
    <div>
      {/* HERO */}
      <section className="relative min-h-[80vh] flex items-center overflow-hidden">
        <img src={images.stageRed} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b0b0d]/85 via-[#0b0b0d]/70 to-[#0b0b0d]" />
        <div className="relative max-w-[1280px] mx-auto px-5 md:px-8 pt-28 w-full">
          <Reveal><SectionLabel light>La experiencia no se improvisa</SectionLabel></Reveal>
          <Reveal delay={100}>
            <h1 className="font-display font-bold uppercase text-4xl md:text-6xl leading-[1.02] text-white max-w-3xl">
              Antes de activar espacios,
              <span className="block text-[var(--mt-red)]">aprendimos a mirar la música desde dentro.</span>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="mt-7 max-w-2xl text-white/70 leading-relaxed">
              MusicTeam nace de una trayectoria construida sobre escenarios, en estudios, escuelas, salas, festivales,
              giras y producciones de muy distinta naturaleza.
            </p>
          </Reveal>
          <Reveal delay={300}>
            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <BtnRed to="/hablemos">Conoce nuestra historia</BtnRed>
              <BtnGhost to="/en-movimiento">Descubre cómo pensamos</BtnGhost>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ORIGEN */}
      <section className="py-24 md:py-32 mt-checker">
        <div className="max-w-[1000px] mx-auto px-5 md:px-8">
          <Reveal><SectionLabel>Una vida dentro de la música</SectionLabel></Reveal>
          <Reveal delay={100}>
            <h2 className="font-display font-bold uppercase text-2xl md:text-4xl text-white leading-tight">
              MusicTeam no empezó con una empresa. Empezó con una forma de entender el oficio.
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <p className="mt-6 text-white/60 leading-relaxed max-w-2xl">
              Primero estuvo el escenario. Después llegaron la docencia, la producción, las giras, las salas, los
              festivales y la coordinación de artistas y equipos técnicos. Cada etapa añadió una mirada distinta:
              la del músico, la del profesor, la del programador, la del productor. De esa suma nació MusicTeam.
            </p>
          </Reveal>
        </div>
      </section>

      {/* MANOLO CRESPO */}
      <section className="bg-[var(--mt-bg-alt)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[var(--mt-red)]" />
              <img src={images.prod1} alt="Manolo Crespo" className="w-full h-[460px] object-cover grayscale brightness-90" />
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div>
              <SectionLabel>Una trayectoria construida desde todos los lados</SectionLabel>
              <h2 className="font-display font-bold uppercase text-2xl md:text-4xl text-white leading-tight">Manolo Crespo</h2>
              <p className="mt-5 text-white/65 leading-relaxed">
                Comenzó su recorrido como músico y docente. Desde 1990 ha formado parte de proyectos de pop, rock,
                jazz, blues, country y orquestas de baile, actuando en escenarios de toda España. Su trayectoria se
                amplió hacia estudios de grabación, medios, escuelas de música, salas, festivales y producciones
                vinculadas a artistas nacionales e internacionales.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {aboutRoles.map((r) => (
                  <span key={r} className="border border-white/15 text-white/60 text-xs font-display uppercase tracking-wider px-3 py-1.5">{r}</span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* KNOWLEDGE BLOCKS */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8">
          <Reveal>
            <SectionLabel>Décadas después</SectionLabel>
            <h2 className="font-display font-bold uppercase text-3xl md:text-5xl text-white leading-tight max-w-2xl">
              La experiencia no sirve para repetir fórmulas. Sirve para decidir mejor.
            </h2>
          </Reveal>
          <div className="grid md:grid-cols-2 gap-5 mt-14">
            {aboutBlocks.map((b, i) => (
              <Reveal key={b.title} delay={(i % 2) * 100}>
                <div className="bg-[var(--mt-bg-card)] border border-white/5 p-8 h-full hover:border-[var(--mt-red)]/50 transition-colors">
                  <span className="font-display uppercase tracking-[0.25em] text-xs text-[var(--mt-red)]">{b.sub}</span>
                  <h3 className="font-display font-bold uppercase text-xl md:text-2xl text-white mt-2">{b.title}</h3>
                  <p className="mt-4 text-white/55 leading-relaxed text-sm">{b.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ALCUBLUES / FESTIVAL BAND */}
      <section className="relative overflow-hidden">
        <img src={images.crowd2} alt="" className="absolute inset-0 w-full h-full object-cover grayscale brightness-[0.35]" />
        <div className="absolute inset-0 bg-[#0b0b0d]/70" />
        <div className="relative max-w-[1000px] mx-auto px-5 md:px-8 py-24 md:py-28 text-center">
          <Reveal>
            <p className="font-display uppercase tracking-[0.28em] text-xs text-white/60 mb-6">Un festival como escuela de realidad</p>
            <h2 className="font-display font-bold uppercase text-3xl md:text-5xl text-white leading-tight">
              Alcublues
            </h2>
            <p className="mt-6 text-white/70 max-w-2xl mx-auto leading-relaxed">
              La dirección del festival permitió reunir muchas de las capacidades que hoy definen a MusicTeam:
              programación, producción, coordinación, relación con artistas, gestión técnica, construcción de
              públicos e identidad cultural. Un festival no se sostiene solo con una buena cartelera: necesita
              criterio, equipo y continuidad.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBanner
        label="Todo lo vivido llega hasta aquí"
        title="La experiencia está detrás."
        redTitle="El próximo espacio, delante."
        text="MusicTeam pone décadas de recorrido al servicio de proyectos que necesitan criterio, producción y una forma distinta de conectar con su público."
        cta="Hablemos de lo que quieres activar"
        image={images.stadium2}
      />
    </div>
  );
}
